/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-conditional */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable max-lines */
/* eslint-disable max-len */
import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import Button from 'Component/Button';
import {
    TYPE_SECONDARY, TYPE_TERTIARY, WIDTH_FULL
} from 'Component/Button/Button.config';
import ChevronIcon from 'Component/ChevronIcon';
import { RIGHT } from 'Component/ChevronIcon/ChevronIcon.config';
import { M_KEY, WHITE_KEY } from 'Component/Icon/Icon.config';
import Popup from 'Component/Popup';
import {
    PLACEHOLDER_COUNTRY_NAME,
    STORE_SWIRCHER_WELCOME_ID,
    WELCOME_PAGE_CLASS
} from 'Component/WelcomePage/WelcomePage.config';
import { CountryType, StoreCountriesType } from 'Type/Stores.type';
import { lazyComponentLoader } from 'Util/lazyComponentLoader';

import {
    STORE_REDIRECT_POPUP
} from './StoreRedirect.config';

import './StoreRedirect.style';

export const StoreSelector = lazyComponentLoader(() => import(
    /* webpackMode: "lazy", webpackChunkName: "store-selector" */
    'Component/StoreSelector'
), 2);

/** @namespace Bodypwa/Component/StoreRedirect/Component */
export class StoreRedirectComponent extends PureComponent {
    static propTypes = {
        selectedCountry: CountryType.isRequired,
        redirectCountry: CountryType.isRequired,
        goToShop: PropTypes.func.isRequired,
        searchRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired,
        headerRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired,
        setDesiredCountry: PropTypes.func.isRequired,
        storeCountries: PropTypes.arrayOf(StoreCountriesType).isRequired,
        isShowStoreSelect: PropTypes.bool.isRequired,
        countryPopupDescription: PropTypes.string.isRequired,
        isShowPopUp: PropTypes.bool.isRequired,
        onRedirect: PropTypes.func.isRequired
    };

    renderFlag(code) {
        if (!code) {
            return null;
        }

        return (
          <span className={ `fi fi-${code?.toLowerCase()}` }>
            <span className="fi-border" />
            <span className="fi-borderGray" />
          </span>
        );
    }

    redirectToShop = () => {
        const {
            goToShop, redirectCountry
        } = this.props;

        goToShop(redirectCountry);
    };

    renderStoreRedirect = () => {
        const {
            selectedCountry: { label, code },
            redirectCountry: { label: redirectLabel, code: redirectCode },
            setDesiredCountry,
            storeCountries,
            isShowStoreSelect,
            countryPopupDescription,
            isShowPopUp,
            onRedirect
        } = this.props;

        const isCom = storeCountries.length > 1;
        document.documentElement.classList.remove(WELCOME_PAGE_CLASS);
        if (!isShowStoreSelect || !isShowPopUp) {
            return null;
        }

        const description = countryPopupDescription ? <div block="StoreRedirect" elem="Description">{ countryPopupDescription.replace(PLACEHOLDER_COUNTRY_NAME, redirectLabel) }</div> : '';
        document.documentElement.classList.add(WELCOME_PAGE_CLASS);

        return (
          <Popup
            id={ STORE_REDIRECT_POPUP }
            clickOutside={ false }
            title="Shipping country"
            isStatic
            isNoTransition
            mix={ { block: 'StoreRedirect' } }
          >
            <div block="StoreRedirect" elem="Content" mods={ { isSimple: false } }>
              { description }
              <div block="StoreRedirect" elem="Buttons" mods={ { isSimple: false, isCom } }>
                <Button
                  isDisabled={ false }
                  mods={ { isHollow: false } }
                  onClick={ setDesiredCountry }
                  width={ WIDTH_FULL }
                  type={ TYPE_TERTIARY }

                >
                      { this.renderFlag(code) }
                      <span block="StoreSelector" elem="Name">{ `Stay on ${label}` }</span>
                      <ChevronIcon size={ M_KEY } direction={ RIGHT } />
                </Button>
                <Button
                  isDisabled={ false }
                  onClick={ this.redirectToShop }
                  width={ WIDTH_FULL }
                  type={ TYPE_SECONDARY }
                >
                      { this.renderFlag(redirectCode) }
                      <span block="StoreSelector" elem="Name">{ `Go to ${redirectLabel}` }</span>
                      <ChevronIcon size={ M_KEY } color={ WHITE_KEY } direction={ RIGHT } />
                </Button>
              </div>
              { this.renderViewAllStores(onRedirect) }
            </div>
          </Popup>
        );
    };

    renderViewAllStores = (onRedirect) => <StoreSelector storeSelectorId={ STORE_SWIRCHER_WELCOME_ID } customLabel="Ship to another country" isPrefered isSimple onRedirect={ onRedirect } />;

    render() {
        return this.renderStoreRedirect();
    }
}

export default StoreRedirectComponent;
